import { IRevenueSpendByAccountRevenueDetailsTableLang } from '../../../types/lang'

export const revenueSpendByAccountRevenueDetailsTableLang: IRevenueSpendByAccountRevenueDetailsTableLang = {
	revenue_spend_by_account_revenue_details_table: {
		column_date_click: 'Date Click',
		column_date_sale: 'Date Sale',
		column_revenue: 'Revenue',
		column_offer: 'Offer',
		column_sub_id: 'Sub ID',
		column_sub_id_2: 'Sub ID 2',
		column_campaign_group: 'Campaign Group',
		column_kt_group: 'KT Group',
		column_original_status: 'Original Status',
	}
}